<template>
  <b-modal
    id="project-staff-modal"
    cancel-variant="outline-secondary"
    :ok-title="isEdit ? $t('generals.save') : $t('generals.create')"
    :cancel-title="$t('generals.cancel')"
    centered
    no-close-on-backdrop
    :title="isEdit ? $t('generals.edit'): $t('generals.create')"
    size="lg"
    @ok="saveClick"
  >
    <!-- @hidden= "form_obj = def_form_obj" -->
    <b-row>
      <b-col md="6">
        <div class="text-center h-100">
          <b-img
            v-if="form_obj.photo"
            class="mb-1"
            style=""
            thumbnail
            fluid
            :src="getImage"
            alt="Фото"
          />
          <div
            v-if="!form_obj.photo"
            class="mb-1"
            style="
                  border: 1px dashed #ccc;
                  padding: 74px;
                  border-radius: 5px;
                  height: 100%;
                "
          >
            {{ $t('references.no_photo') }}
          </div>
        </div>
        <b-form-file
          v-model="form_obj.photo"
          accept="image/*"
          :placeholder="$t('references.upload_file')"
          :browse-text="$t('references.upload')"
        />
      </b-col>
      <b-col
        md="6"
      >
        <validation-observer ref="officeValidations">
          <b-tabs>
            <b-tab title="Uz">
              <!-- <validated-form
            :form_fields="getFormFields"
            :def_form_obj="form_obj"
            @field_update="form => form_obj = form"
          /> -->
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('clients.full_name')"
                  rules="required"
                >
                  <label for="full_name">{{ $t('clients.full_name') }}</label>
                  <b-form-input
                    id="full_name"
                    v-model="form_obj.full_name.uz"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('references.position')"
                  rules="required"
                >
                  <label for="position">{{ $t('references.position') }}</label>
                  <b-form-input
                    id="position"
                    v-model="form_obj.position.uz"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <label for="desc_uz">{{ $t('objects.description') }}</label>
              <b-form-textarea
                id="desc_uz"
                v-model="form_obj.description.uz"
              />
            </b-tab>
            <b-tab title="Ru">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('clients.full_name')"
                  rules="required"
                >
                  <label for="full_name">{{ $t('clients.full_name') }}</label>
                  <b-form-input
                    id="full_name"
                    v-model="form_obj.full_name.ru"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('references.position')"
                  rules="required"
                >
                  <label for="position">{{ $t('references.position') }}</label>
                  <b-form-input
                    id="position"
                    v-model="form_obj.position.ru"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <label for="desc_ru">{{ $t('objects.description') }}</label>
              <b-form-textarea
                id="desc_ru"
                v-model="form_obj.description.ru"
              />
            </b-tab>
          </b-tabs>
        </validation-observer>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BImg, BTabs, BTab, BFormTextarea, BFormFile, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import { required } from '@validations'
// import validatedForm from '@/components/validatedForm.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BModal,
    // validatedForm,
    ValidationObserver,
    ValidationProvider,
    BRow,
    BCol,
    BImg,
    BTabs,
    BTab,
    BFormTextarea,
    BFormFile,
    BFormInput,
    BFormGroup,
  },
  mixins: [formatters],
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defFormObj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      required,
      form_obj: {
        description: {},
        position: {},
        full_name: {},
      },
      image_preview: '',
    }
  },
  computed: {
    getImage() {
      if (!(this.form_obj.photo instanceof File)) {
        return this.form_obj.photo
      }
      return this.image_preview
    },
  },
  watch: {
    defFormObj() {
      this.form_obj = this.defFormObj
    },
    'form_obj.photo': async function (newVal) {
      // this.$_convertToBase64(this.new_file).then(res => {
      //   this.photo = res
      // })
      this.image_preview = await this.$_convertToBase64(newVal)
    },
  },
  mounted() {
    this.form_obj = this.defFormObj
  },
  methods: {
    ...mapActions('knowledgeBase', ['ADD_PROJECT_STAFF', 'EDIT_PROJECT_STAFF']),
    saveClick(bvModal) {
      bvModal.preventDefault()
      this.$refs.officeValidations.validate().then(success => {
        if (success) {
          console.log(this.form_obj)
          if (!(this.form_obj.photo instanceof File)) {
            this.$delete(this.form_obj, 'photo')
          }
          this.form_obj.full_name = JSON.stringify(this.form_obj.full_name)
          this.form_obj.position = JSON.stringify(this.form_obj.position)
          this.form_obj.description = JSON.stringify(this.form_obj.description)
          // const fd = new FormData()
          // Object.keys(this.form_obj).forEach(el => {
          //   fd.append(el, this.form_obj[el])
          // })
          const fd = this.$_objectToFormData(this.form_obj)
          if (this.isEdit) {
            this.EDIT_PROJECT_STAFF(fd).then(() => {
              this.$emit('addSuccess')
              this.$bvModal.hide('project-staff-modal')
              this.$_successToast(this.$t('generals.changed'))
            }).catch(() => {
              this.$_errorToast('Ошибка')
            })
          } else {
            this.ADD_PROJECT_STAFF(fd).then(() => {
              this.$emit('addSuccess')
              this.$bvModal.hide('project-staff-modal')
              this.$_successToast(this.$t('generals.added'))
            }).catch(() => {
              this.$_errorToast(this.$t('generals.error'))
            })
          }
        }
      })
    },
  },
}
</script>

<style></style>
